import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

interface NextStepsSectionProps {
  nextSteps: string;
  continueUrl: string;
}

const NextStepsSection: React.FC<NextStepsSectionProps> = ({
  nextSteps,
  continueUrl,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Next Steps</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="mb-6">{nextSteps}</p>

        <Link to={continueUrl}>
          <Button className="w-full bg-honeycomb hover:bg-amber-500 text-white">
            Continue Application
            <ChevronRight className="ml-2 h-4 w-4" />
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};

export default NextStepsSection;
